import { Navigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";

interface PropsTypes {
  component: React.ComponentType;
  redirectTo: string;
}

export const PrivateRoute: React.FC<PropsTypes> = ({
  component: Component,
  redirectTo = "/",
}) => {
  const { user } = useAuthStore();

  // return user!.isLoggedIn ? <Component /> : <Navigate to={redirectTo} />;
  if (user?.isLoggedIn) {
    return <Component />;
  } else {
    return <Navigate to={redirectTo} />;
  }
};
